webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _vue = __webpack_require__(176);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(175);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Add = __webpack_require__(167);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var Layout = {
	  template: '\n    <div>\n      <router-view class="view"></router-view>\n    </div>\n  '
	};
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  base: __dirname,
	  linkActiveClass: 'active',
	  routes: [{ path: '/', name: 'invoices/add', component: _Add2.default }]
	});
	
	Layout.router = router;
	new _vue2.default(Layout).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },

/***/ 116:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(155)
	__webpack_require__(154)
	
	/* script */
	__vue_exports__ = __webpack_require__(117)
	
	/* template */
	var __vue_template__ = __webpack_require__(170)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3"
	
	module.exports = __vue_exports__


/***/ },

/***/ 117:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accounting = __webpack_require__(2);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _flatpickr = __webpack_require__(160);
	
	var _flatpickr2 = _interopRequireDefault(_flatpickr);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['value', 'id', 'class', 'number', 'block', 'money', 'multiline', 'date'],
	  data: function data() {
	    return {
	      val: this.isMoney ? this.toMoney(this.value) : this.value,
	      datePicker: null
	    };
	  },
	
	  computed: {
	    isNumber: function isNumber() {
	      return this.number === '';
	    },
	    isMultiline: function isMultiline() {
	      return this.multiline === '';
	    },
	    isMoney: function isMoney() {
	      return this.money === '';
	    },
	    isBlock: function isBlock() {
	      return this.block === '';
	    },
	    isDate: function isDate() {
	      return this.date === '';
	    },
	    classes: function classes() {
	      var answer = {
	        empty: this.val.length < 1
	      };
	      if (this.class) {
	        answer[this.class] = true;
	      }
	      if (this.isBlock) {
	        answer.block = true;
	      }
	      if (this.isMultiline) {
	        answer.multiline = true;
	      }
	      return answer;
	    }
	  },
	  created: function created() {
	    if (this.isMoney) {
	      this.val = this.toMoney(this.val);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.isDate) {
	      (function () {
	        var that = _this;
	        _this.datePicker = new _flatpickr2.default(_this.$refs.input, {
	          dateFormat: 'd.m.Y',
	          allowInput: true,
	          defaultDate: (0, _moment2.default)(that.val, 'DD.MM.YYYY').toDate(),
	          onReady: function onReady(dateObj, dateStr, instance) {
	            instance.calendarContainer.classList.remove('arrowTop');
	            that.$refs.container.appendChild(instance.calendarContainer);
	          },
	          onChange: function onChange(dateObj, dateStr, instance) {
	            that.val = dateStr;
	          }
	        });
	      })();
	    }
	  },
	
	  watch: {
	    val: function val(v) {
	      if (this.isMoney) {
	        var value = this.fromMoney(v);
	        this.$emit('change', value);
	      } else {
	        this.$emit('change', v);
	      }
	    }
	  },
	  methods: {
	    fromMoney: function fromMoney(value) {
	      return 100 * _accounting2.default.unformat(value, ',');
	    },
	    toMoney: function toMoney(value) {
	      return _accounting2.default.formatNumber(value / 100, 2, '.', ',');
	    },
	    blur: function blur() {
	      document.activeElement.blur();
	    },
	    onBlur: function onBlur() {
	      var value = this.$refs.input.value;
	      if (this.isMoney) {
	        this.val = this.toMoney(this.fromMoney(value));
	      } else {
	        this.val = value;
	      }
	    }
	  }
	};

/***/ },

/***/ 118:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(124);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _accounting = __webpack_require__(2);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _Editable = __webpack_require__(116);
	
	var _Editable2 = _interopRequireDefault(_Editable);
	
	var _InvoiceList = __webpack_require__(163);
	
	var _InvoiceList2 = _interopRequireDefault(_InvoiceList);
	
	var _InvoiceSummary = __webpack_require__(165);
	
	var _InvoiceSummary2 = _interopRequireDefault(_InvoiceSummary);
	
	var _InvoiceTotal = __webpack_require__(166);
	
	var _InvoiceTotal2 = _interopRequireDefault(_InvoiceTotal);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyProduct = {
	  name: '',
	  quantity: 1,
	  quantityType: 'usł.',
	  priceNetto: 0,
	  vat: 23,
	  nettoValue: 0,
	  vatValue: 0,
	  bruttoValue: 0
	};
	
	exports.default = {
	  data: function data() {
	    return {
	      invoice: {
	        title: 'Faktura VAT',
	        id: (0, _moment2.default)().format('YYYY/MMDD') + '01',
	        place: '',
	        date: (0, _moment2.default)().format('DD.MM.YYYY'),
	        deliveryDate: (0, _moment2.default)().format('DD.MM.YYYY'),
	        seller: '',
	        buyer: '',
	        paymentDate: (0, _moment2.default)().add(14, 'days').format('DD.MM.YYYY'),
	        paymentType: 'Przelew',
	        sellerSignature: '',
	        buyerSignature: '',
	        products: [(0, _assign2.default)({}, emptyProduct)],
	        footer: [{
	          id: Math.random(),
	          name: 'Numer konta',
	          value: 'xx xxxx xxxx xxxx xxxx xxxx xxxx (bank)'
	        }]
	      }
	    };
	  },
	
	  computed: {
	    total: function total() {
	      var total = 0;
	      this.invoice.products.forEach(function (s) {
	        total += s.bruttoValue;
	      });
	      return total;
	    }
	  },
	  methods: {
	    money: function money(value) {
	      return _accounting2.default.formatNumber(value / 100, 2, '.', ',');
	    },
	    newProduct: function newProduct() {
	      this.invoice.products.push((0, _assign2.default)({ id: Math.random() }, emptyProduct));
	      setTimeout(function () {
	        document.querySelector('#product-list tr:last-child input').focus();
	      }, 0);
	    },
	    changeProduct: function changeProduct(index, product) {
	      this.invoice.products[index] = product;
	    },
	    removeProduct: function removeProduct(index) {
	      this.invoice.products.splice(index, 1);
	      if (!this.invoice.products.length) {
	        this.newProduct();
	      }
	      setTimeout(function () {
	        var el = document.querySelector('#product-list tr:nth-child(' + (index + 1) + ') button') || document.querySelector('#product-list tr:last-child button');
	        el.focus();
	      }, 0);
	    },
	    removeFooter: function removeFooter(index) {
	      this.invoice.footer.splice(index, 1);
	    },
	    addFooter: function addFooter() {
	      this.invoice.footer.push({
	        id: Math.random(),
	        name: '',
	        value: ''
	      });
	      setTimeout(function () {
	        document.querySelector('#foot tr:last-child input').focus();
	      }, 0);
	    }
	  },
	  components: {
	    Editable: _Editable2.default,
	    Products: _InvoiceList2.default,
	    ProductsSummary: _InvoiceSummary2.default,
	    ProductsTotal: _InvoiceTotal2.default
	  }
	};

/***/ },

/***/ 119:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InvoiceRow = __webpack_require__(164);
	
	var _InvoiceRow2 = _interopRequireDefault(_InvoiceRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['products', 'id'],
	  methods: {
	    removeProduct: function removeProduct(index) {
	      this.$emit('remove', index);
	    },
	    changeProduct: function changeProduct(index, key, value) {
	      var product = this.products[index];
	      product[key] = value;
	      this.$emit('change', index, product);
	    }
	  },
	  components: {
	    Product: _InvoiceRow2.default
	  }
	};

/***/ },

/***/ 120:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accounting = __webpack_require__(2);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _Editable = __webpack_require__(116);
	
	var _Editable2 = _interopRequireDefault(_Editable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['product', 'index', 'positionNumber'],
	  data: function data() {
	    return {
	      name: this.product.name,
	      quantity: this.product.quantity,
	      quantityType: this.product.quantityType,
	      priceNetto: this.product.priceNetto,
	      vat: this.product.vat
	    };
	  },
	
	  computed: {
	    nettoValue: function nettoValue() {
	      return this.quantity * this.priceNetto;
	    },
	    vatValue: function vatValue() {
	      return this.nettoValue * this.vat / 100;
	    },
	    bruttoValue: function bruttoValue() {
	      return this.nettoValue + this.vatValue;
	    }
	  },
	  watch: {
	    name: function name(value) {
	      this.changeProduct('name', value);
	    },
	    quantity: function quantity(value) {
	      this.changeProduct('quantity', value);
	    },
	    quantityType: function quantityType(value) {
	      this.changeProduct('quantityType', value);
	    },
	    priceNetto: function priceNetto(value) {
	      this.changeProduct('priceNetto', value);
	    },
	    vat: function vat(value) {
	      this.changeProduct('vat', value);
	    },
	    nettoValue: function nettoValue(value) {
	      this.changeProduct('nettoValue', value);
	    },
	    vatValue: function vatValue(value) {
	      this.changeProduct('vatValue', value);
	    },
	    bruttoValue: function bruttoValue(value) {
	      this.changeProduct('bruttoValue', value);
	    }
	  },
	  methods: {
	    money: function money(value) {
	      return _accounting2.default.formatNumber(value / 100, 2, '.', ',');
	    },
	    removeProduct: function removeProduct() {
	      this.$emit('remove', this.index);
	    },
	    changeProduct: function changeProduct(key, value) {
	      this.$emit('change', this.index, key, value);
	    }
	  },
	  components: {
	    Editable: _Editable2.default
	  }
	};

/***/ },

/***/ 121:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accounting = __webpack_require__(2);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['products', 'id'],
	  computed: {
	    summary: function summary() {
	      var answer = [];
	      var vats = {};
	      this.products.forEach(function (p) {
	        var vat = String(p.vat);
	        var v = vats[vat] || { vat: p.vat, nettoValue: 0, vatValue: 0, bruttoValue: 0 };
	        v.nettoValue += p.nettoValue;
	        v.vatValue += p.vatValue;
	        v.bruttoValue += p.bruttoValue;
	        vats[vat] = v;
	      });
	      for (var k in vats) {
	        answer.push(vats[k]);
	      }
	      return answer.sort(function (a, b) {
	        return a - b;
	      });
	    }
	  },
	  methods: {
	    money: function money(value) {
	      return _accounting2.default.formatNumber(value / 100, 2, '.', ',');
	    },
	    newProduct: function newProduct() {
	      this.$emit('new');
	    }
	  }
	};

/***/ },

/***/ 122:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accounting = __webpack_require__(2);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['products', 'id'],
	  computed: {
	    total: function total() {
	      var total = { nettoValue: 0, vatValue: 0, bruttoValue: 0 };
	      this.products.forEach(function (s) {
	        total.nettoValue += s.nettoValue;
	        total.vatValue += s.vatValue;
	        total.bruttoValue += s.bruttoValue;
	      });
	      return total;
	    }
	  },
	  methods: {
	    money: function money(value) {
	      return _accounting2.default.formatNumber(value / 100, 2, '.', ',');
	    }
	  }
	};

/***/ },

/***/ 123:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Add = __webpack_require__(162);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InvoicesAdd: _Add2.default
	  }
	};

/***/ },

/***/ 152:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 153:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 154:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 155:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 156:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 157:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 158:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 159:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 161:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 12,
		"./af.js": 12,
		"./ar": 17,
		"./ar-ly": 13,
		"./ar-ly.js": 13,
		"./ar-ma": 14,
		"./ar-ma.js": 14,
		"./ar-sa": 15,
		"./ar-sa.js": 15,
		"./ar-tn": 16,
		"./ar-tn.js": 16,
		"./ar.js": 17,
		"./az": 18,
		"./az.js": 18,
		"./be": 19,
		"./be.js": 19,
		"./bg": 20,
		"./bg.js": 20,
		"./bn": 21,
		"./bn.js": 21,
		"./bo": 22,
		"./bo.js": 22,
		"./br": 23,
		"./br.js": 23,
		"./bs": 24,
		"./bs.js": 24,
		"./ca": 25,
		"./ca.js": 25,
		"./cs": 26,
		"./cs.js": 26,
		"./cv": 27,
		"./cv.js": 27,
		"./cy": 28,
		"./cy.js": 28,
		"./da": 29,
		"./da.js": 29,
		"./de": 31,
		"./de-at": 30,
		"./de-at.js": 30,
		"./de.js": 31,
		"./dv": 32,
		"./dv.js": 32,
		"./el": 33,
		"./el.js": 33,
		"./en-au": 34,
		"./en-au.js": 34,
		"./en-ca": 35,
		"./en-ca.js": 35,
		"./en-gb": 36,
		"./en-gb.js": 36,
		"./en-ie": 37,
		"./en-ie.js": 37,
		"./en-nz": 38,
		"./en-nz.js": 38,
		"./eo": 39,
		"./eo.js": 39,
		"./es": 41,
		"./es-do": 40,
		"./es-do.js": 40,
		"./es.js": 41,
		"./et": 42,
		"./et.js": 42,
		"./eu": 43,
		"./eu.js": 43,
		"./fa": 44,
		"./fa.js": 44,
		"./fi": 45,
		"./fi.js": 45,
		"./fo": 46,
		"./fo.js": 46,
		"./fr": 49,
		"./fr-ca": 47,
		"./fr-ca.js": 47,
		"./fr-ch": 48,
		"./fr-ch.js": 48,
		"./fr.js": 49,
		"./fy": 50,
		"./fy.js": 50,
		"./gd": 51,
		"./gd.js": 51,
		"./gl": 52,
		"./gl.js": 52,
		"./he": 53,
		"./he.js": 53,
		"./hi": 54,
		"./hi.js": 54,
		"./hr": 55,
		"./hr.js": 55,
		"./hu": 56,
		"./hu.js": 56,
		"./hy-am": 57,
		"./hy-am.js": 57,
		"./id": 58,
		"./id.js": 58,
		"./is": 59,
		"./is.js": 59,
		"./it": 60,
		"./it.js": 60,
		"./ja": 61,
		"./ja.js": 61,
		"./jv": 62,
		"./jv.js": 62,
		"./ka": 63,
		"./ka.js": 63,
		"./kk": 64,
		"./kk.js": 64,
		"./km": 65,
		"./km.js": 65,
		"./ko": 66,
		"./ko.js": 66,
		"./ky": 67,
		"./ky.js": 67,
		"./lb": 68,
		"./lb.js": 68,
		"./lo": 69,
		"./lo.js": 69,
		"./lt": 70,
		"./lt.js": 70,
		"./lv": 71,
		"./lv.js": 71,
		"./me": 72,
		"./me.js": 72,
		"./mi": 73,
		"./mi.js": 73,
		"./mk": 74,
		"./mk.js": 74,
		"./ml": 75,
		"./ml.js": 75,
		"./mr": 76,
		"./mr.js": 76,
		"./ms": 78,
		"./ms-my": 77,
		"./ms-my.js": 77,
		"./ms.js": 78,
		"./my": 79,
		"./my.js": 79,
		"./nb": 80,
		"./nb.js": 80,
		"./ne": 81,
		"./ne.js": 81,
		"./nl": 82,
		"./nl.js": 82,
		"./nn": 83,
		"./nn.js": 83,
		"./pa-in": 84,
		"./pa-in.js": 84,
		"./pl": 85,
		"./pl.js": 85,
		"./pt": 87,
		"./pt-br": 86,
		"./pt-br.js": 86,
		"./pt.js": 87,
		"./ro": 88,
		"./ro.js": 88,
		"./ru": 89,
		"./ru.js": 89,
		"./se": 90,
		"./se.js": 90,
		"./si": 91,
		"./si.js": 91,
		"./sk": 92,
		"./sk.js": 92,
		"./sl": 93,
		"./sl.js": 93,
		"./sq": 94,
		"./sq.js": 94,
		"./sr": 96,
		"./sr-cyrl": 95,
		"./sr-cyrl.js": 95,
		"./sr.js": 96,
		"./ss": 97,
		"./ss.js": 97,
		"./sv": 98,
		"./sv.js": 98,
		"./sw": 99,
		"./sw.js": 99,
		"./ta": 100,
		"./ta.js": 100,
		"./te": 101,
		"./te.js": 101,
		"./th": 102,
		"./th.js": 102,
		"./tl-ph": 103,
		"./tl-ph.js": 103,
		"./tlh": 104,
		"./tlh.js": 104,
		"./tr": 105,
		"./tr.js": 105,
		"./tzl": 106,
		"./tzl.js": 106,
		"./tzm": 108,
		"./tzm-latn": 107,
		"./tzm-latn.js": 107,
		"./tzm.js": 108,
		"./uk": 109,
		"./uk.js": 109,
		"./uz": 110,
		"./uz.js": 110,
		"./vi": 111,
		"./vi.js": 111,
		"./x-pseudo": 112,
		"./x-pseudo.js": 112,
		"./zh-cn": 113,
		"./zh-cn.js": 113,
		"./zh-hk": 114,
		"./zh-hk.js": 114,
		"./zh-tw": 115,
		"./zh-tw.js": 115
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 161;


/***/ },

/***/ 162:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(153)
	
	/* script */
	__vue_exports__ = __webpack_require__(118)
	
	/* template */
	var __vue_template__ = __webpack_require__(169)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2"
	
	module.exports = __vue_exports__


/***/ },

/***/ 163:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(158)
	
	/* script */
	__vue_exports__ = __webpack_require__(119)
	
	/* template */
	var __vue_template__ = __webpack_require__(173)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6"
	
	module.exports = __vue_exports__


/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(159)
	
	/* script */
	__vue_exports__ = __webpack_require__(120)
	
	/* template */
	var __vue_template__ = __webpack_require__(174)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7"
	
	module.exports = __vue_exports__


/***/ },

/***/ 165:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(156)
	
	/* script */
	__vue_exports__ = __webpack_require__(121)
	
	/* template */
	var __vue_template__ = __webpack_require__(171)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4"
	
	module.exports = __vue_exports__


/***/ },

/***/ 166:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(157)
	
	/* script */
	__vue_exports__ = __webpack_require__(122)
	
	/* template */
	var __vue_template__ = __webpack_require__(172)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5"
	
	module.exports = __vue_exports__


/***/ },

/***/ 167:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(152)
	
	/* script */
	__vue_exports__ = __webpack_require__(123)
	
	/* template */
	var __vue_template__ = __webpack_require__(168)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1"
	
	module.exports = __vue_exports__


/***/ },

/***/ 168:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', [_h('invoices-add')])
	}},staticRenderFns: []}

/***/ },

/***/ 169:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', [_h('table', {
	    attrs: {
	      "id": "head"
	    }
	  }, [_h('tr', [_m(0), " ", _m(1), " ", _h('td', [_h('editable', {
	    attrs: {
	      "id": ("place-" + _uid)
	    },
	    domProps: {
	      "value": invoice.place
	    },
	    on: {
	      "change": function($event) {
	        invoice.place = $event
	      }
	    }
	  })])]), " ", _h('tr', [_m(2), " ", _m(3), " ", _h('td', [_h('editable', {
	    attrs: {
	      "date": "",
	      "id": ("date-" + _uid)
	    },
	    domProps: {
	      "value": invoice.date
	    },
	    on: {
	      "change": function($event) {
	        invoice.date = $event
	      }
	    }
	  })])]), " ", _h('tr', [_m(4), " ", _m(5), " ", _h('td', [_h('editable', {
	    attrs: {
	      "date": "",
	      "id": ("deliveryDate-" + _uid)
	    },
	    domProps: {
	      "value": invoice.deliveryDate
	    },
	    on: {
	      "change": function($event) {
	        invoice.deliveryDate = $event
	      }
	    }
	  })])])]), " ", _h('section', {
	    attrs: {
	      "id": "seller"
	    }
	  }, [_m(6), " ", _h('p', [_h('editable', {
	    attrs: {
	      "multiline": "",
	      "id": ("seller-" + _uid)
	    },
	    domProps: {
	      "value": invoice.seller
	    },
	    on: {
	      "change": function($event) {
	        invoice.seller = $event
	      }
	    }
	  })])]), " ", _h('section', {
	    attrs: {
	      "id": "buyer"
	    }
	  }, [_m(7), " ", _h('p', [_h('editable', {
	    attrs: {
	      "multiline": "",
	      "id": ("buyer-" + _uid)
	    },
	    domProps: {
	      "value": invoice.buyer
	    },
	    on: {
	      "change": function($event) {
	        invoice.buyer = $event
	      }
	    }
	  })])]), " ", _h('h1', [_h('editable', {
	    attrs: {
	      "id": ("title-" + _uid)
	    },
	    domProps: {
	      "value": invoice.title
	    },
	    on: {
	      "change": function($event) {
	        invoice.title = $event
	      }
	    }
	  })]), " ", _h('h2', [_h('editable', {
	    attrs: {
	      "id": ("id-" + _uid)
	    },
	    domProps: {
	      "value": invoice.id
	    },
	    on: {
	      "change": function($event) {
	        invoice.id = $event
	      }
	    }
	  })]), " ", _h('table', {
	    attrs: {
	      "id": "products"
	    }
	  }, [_m(8), " ", _h('products', {
	    attrs: {
	      "id": "product-list",
	      "products": invoice.products
	    },
	    on: {
	      "remove": removeProduct,
	      "change": changeProduct
	    }
	  }), " ", _h('products-summary', {
	    attrs: {
	      "id": "summary",
	      "products": invoice.products
	    },
	    on: {
	      "new": newProduct
	    }
	  }), " ", _h('products-total', {
	    attrs: {
	      "id": "total",
	      "products": invoice.products
	    }
	  })]), " ", _h('table', {
	    attrs: {
	      "id": "foot"
	    }
	  }, [_h('tbody', [_h('tr', [_m(9), " ", _m(10), " ", _h('td', [_s(money(total)) + " ", _m(11)])]), " ", _h('tr', [_m(12), " ", _m(13), " ", _h('td', [_h('editable', {
	    attrs: {
	      "date": "",
	      "id": ("paymentDate-" + _uid)
	    },
	    domProps: {
	      "value": invoice.paymentDate
	    },
	    on: {
	      "change": function($event) {
	        invoice.paymentDate = $event
	      }
	    }
	  })])]), " ", _h('tr', [_m(14), " ", _m(15), " ", _h('td', [_h('editable', {
	    attrs: {
	      "id": ("paymentType-" + _uid)
	    },
	    domProps: {
	      "value": invoice.paymentType
	    },
	    on: {
	      "change": function($event) {
	        invoice.paymentType = $event
	      }
	    }
	  })])]), " ", (invoice.footer) && _l((invoice.footer), function(f, idx) {
	    return _h('tr', {
	      key: f.id,
	      class: {
	        empty: f.name === ''
	      }
	    }, [_h('th', [_h('button', {
	      on: {
	        "click": function($event) {
	          removeFooter(idx)
	        }
	      }
	    }, ["Usuń"]), _h('editable', {
	      attrs: {
	        "id": ("footer-name-" + idx + "-" + _uid)
	      },
	      domProps: {
	        "value": f.name
	      },
	      on: {
	        "change": function($event) {
	          f.name = $event
	        }
	      }
	    })]), " ", _m(16, true), " ", _h('td', [_h('editable', {
	      attrs: {
	        "id": ("footer-value-" + idx + "-" + _uid)
	      },
	      domProps: {
	        "value": f.value
	      },
	      on: {
	        "change": function($event) {
	          f.value = $event
	        }
	      }
	    })])])
	  })]), " ", _h('tbody', [_h('tr', [_h('td', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_h('button', {
	    on: {
	      "click": function($event) {
	        addFooter()
	      }
	    }
	  }, ["Dodaj"])])])])]), " ", _h('section', {
	    staticClass: "signature"
	  }, [_h('p', [_h('editable', {
	    attrs: {
	      "id": ("buyerSignature-" + _uid)
	    },
	    domProps: {
	      "value": invoice.buyerSignature
	    },
	    on: {
	      "change": function($event) {
	        invoice.buyerSignature = $event
	      }
	    }
	  })]), " ", _m(17)]), " ", _h('section', {
	    staticClass: "signature"
	  }, [_h('p', [_h('editable', {
	    attrs: {
	      "id": ("sellerSignature-" + _uid)
	    },
	    domProps: {
	      "value": invoice.sellerSignature
	    },
	    on: {
	      "change": function($event) {
	        invoice.sellerSignature = $event
	      }
	    }
	  })]), " ", _m(18)])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('th', ["Miejsce wystawienia"])
	}},function (){with(this) {
	  return _h('td', [":"])
	}},function (){with(this) {
	  return _h('th', ["Data wystawienia"])
	}},function (){with(this) {
	  return _h('td', [":"])
	}},function (){with(this) {
	  return _h('th', ["Data wykonania usługi"])
	}},function (){with(this) {
	  return _h('td', [":"])
	}},function (){with(this) {
	  return _h('h3', ["Sprzedawca"])
	}},function (){with(this) {
	  return _h('h3', ["Nabywca"])
	}},function (){with(this) {
	  return _h('thead', [_h('tr', [_h('td', [_h('span', ["Lp"])]), " ", _h('td', [_h('span', ["Nazwa usługi"])]), " ", _h('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_h('span', ["Ilość", _h('br'), "J.m."])]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('span', ["Cena netto", _h('small', ["[PLN]"])])]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('span', ["VAT", _h('small', ["[%]"])])]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('span', ["Wartość netto", _h('small', ["[PLN]"])])]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('span', ["Wartość VAT", _h('small', ["[PLN]", _h('small')])])]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('span', ["Wartość brutto", _h('small', ["[PLN]"])])])])])
	}},function (){with(this) {
	  return _h('th', ["Do zapłaty"])
	}},function (){with(this) {
	  return _h('td')
	}},function (){with(this) {
	  return _h('small', ["PLN"])
	}},function (){with(this) {
	  return _h('th', ["Termin płatności"])
	}},function (){with(this) {
	  return _h('td')
	}},function (){with(this) {
	  return _h('th', ["Forma płatności"])
	}},function (){with(this) {
	  return _h('td')
	}},function (){with(this) {
	  return _h('td')
	}},function (){with(this) {
	  return _h('small', ["Imię, nazwisko i podpis osoby uprawnionej do odbioru dokumentu"])
	}},function (){with(this) {
	  return _h('small', ["Podpis osoby uprawnionej do wystawienia dokumentu"])
	}}]}

/***/ },

/***/ 170:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('span', {
	    class: classes
	  }, [(isMoney) ? _h('input', {
	    directives: [{
	      name: "model",
	      value: (val),
	      expression: "val",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    ref: "input",
	    attrs: {
	      "id": id,
	      "size": String(val).length || 1
	    },
	    domProps: {
	      "value": _s(val)
	    },
	    on: {
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) return;
	        blur()
	      },
	      "blur": function($event) {
	        onBlur()
	      },
	      "input": function($event) {
	        if ($event.target.composing) return;
	        val = $event.target.value.trim()
	      }
	    }
	  }) : _e(), " ", (isNumber) ? _h('input', {
	    directives: [{
	      name: "model",
	      value: (val),
	      expression: "val",
	      modifiers: {
	        "number": true,
	        "trim": true
	      }
	    }],
	    ref: "input",
	    attrs: {
	      "id": id,
	      "size": String(val).length || 1
	    },
	    domProps: {
	      "value": _s(val)
	    },
	    on: {
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) return;
	        blur()
	      },
	      "blur": function($event) {
	        onBlur()
	      },
	      "input": function($event) {
	        if ($event.target.composing) return;
	        val = _n($event.target.value.trim())
	      }
	    }
	  }) : _e(), " ", (isMultiline) ? _h('textarea', {
	    directives: [{
	      name: "model",
	      value: (val),
	      expression: "val"
	    }],
	    ref: "input",
	    attrs: {
	      "id": id,
	      "rows": val.split('\n').length || 1
	    },
	    domProps: {
	      "value": _s(val)
	    },
	    on: {
	      "blur": function($event) {
	        onBlur()
	      },
	      "input": function($event) {
	        if ($event.target.composing) return;
	        val = $event.target.value
	      }
	    }
	  }) : _e(), " ", (!isNumber && !isMoney && !isMultiline) ? _h('input', {
	    directives: [{
	      name: "model",
	      value: (val),
	      expression: "val",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    ref: "input",
	    attrs: {
	      "id": id,
	      "size": val.length || 1
	    },
	    domProps: {
	      "value": _s(val)
	    },
	    on: {
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) return;
	        blur()
	      },
	      "blur": function($event) {
	        onBlur()
	      },
	      "input": function($event) {
	        if ($event.target.composing) return;
	        val = $event.target.value.trim()
	      }
	    }
	  }) : _e(), " ", _h('label', {
	    attrs: {
	      "for": id
	    }
	  }, [_s(val)]), (isDate) ? _h('span', {
	    ref: "container"
	  }) : _e()])
	}},staticRenderFns: []}

/***/ },

/***/ 171:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('tbody', {
	    attrs: {
	      "id": "id"
	    }
	  }, [(summary) && _l((summary), function(s) {
	    return _h('tr', [_h('td', {
	      staticClass: "empty",
	      attrs: {
	        "colspan": "5"
	      }
	    }, [_h('button', {
	      on: {
	        "click": newProduct
	      }
	    }, ["Dodaj"])]), " ", _h('th', {
	      staticClass: "number"
	    }, [_s(s.vat)]), " ", _h('td', {
	      staticClass: "number"
	    }, [_s(money(s.nettoValue))]), " ", _h('td', {
	      staticClass: "number"
	    }, [_s(money(s.vatValue))]), " ", _h('td', {
	      staticClass: "number"
	    }, [_s(money(s.bruttoValue))])])
	  })])
	}},staticRenderFns: []}

/***/ },

/***/ 172:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('tbody', {
	    attrs: {
	      "id": id
	    }
	  }, [_h('tr', [_m(0), " ", _h('td', {
	    staticClass: "number"
	  }, [_s(money(total.nettoValue))]), " ", _h('td', {
	    staticClass: "number"
	  }, [_s(money(total.vatValue))]), " ", _h('td', {
	    staticClass: "number"
	  }, [_s(money(total.bruttoValue))])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('th', {
	    staticClass: "empty",
	    attrs: {
	      "colspan": "6"
	    }
	  }, ["Razem"])
	}}]}

/***/ },

/***/ 173:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('tbody', {
	    attrs: {
	      "id": id
	    }
	  }, [(products) && _l((products), function(product, index) {
	    return _h('product', {
	      key: product.id,
	      attrs: {
	        "product": product,
	        "position-number": index + 1,
	        "index": index
	      },
	      on: {
	        "remove": removeProduct,
	        "change": changeProduct
	      }
	    })
	  })])
	}},staticRenderFns: []}

/***/ },

/***/ 174:
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('tr', [_h('td', {
	    staticClass: "number"
	  }, [_h('button', {
	    on: {
	      "click": removeProduct
	    }
	  }, ["Usuń"]), "\n    " + _s(positionNumber) + ".\n  "]), " ", _h('td', [_h('editable', {
	    attrs: {
	      "block": "",
	      "id": ("name-" + _uid)
	    },
	    domProps: {
	      "value": name
	    },
	    on: {
	      "change": function($event) {
	        name = $event
	      }
	    }
	  })]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('editable', {
	    attrs: {
	      "number": "",
	      "id": ("quantity-" + _uid)
	    },
	    domProps: {
	      "value": quantity
	    },
	    on: {
	      "change": function($event) {
	        quantity = $event
	      }
	    }
	  })]), " ", _h('td', [_h('editable', {
	    attrs: {
	      "id": ("quantityType-" + _uid)
	    },
	    domProps: {
	      "value": quantityType
	    },
	    on: {
	      "change": function($event) {
	        quantityType = $event
	      }
	    }
	  })]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('editable', {
	    attrs: {
	      "money": "",
	      "id": ("priceNetto-" + _uid)
	    },
	    domProps: {
	      "value": priceNetto
	    },
	    on: {
	      "change": function($event) {
	        priceNetto = $event
	      }
	    }
	  })]), " ", _h('td', {
	    staticClass: "number"
	  }, [_h('editable', {
	    attrs: {
	      "number": "",
	      "id": ("vat-" + _uid)
	    },
	    domProps: {
	      "value": vat
	    },
	    on: {
	      "change": function($event) {
	        vat = $event
	      }
	    }
	  })]), " ", _h('td', {
	    staticClass: "number"
	  }, [_s(money(nettoValue))]), " ", _h('td', {
	    staticClass: "number"
	  }, [_s(money(vatValue))]), " ", _h('td', {
	    staticClass: "number"
	  }, [_s(money(bruttoValue))])])
	}},staticRenderFns: []}

/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/app.6cbc9a9d97f1ca837b59.js
 **/